<template>
  <div class="block-b">
    <div class="block-b__bg js-parallax-1"></div>
    <div class="block-b__content">
      <div class="block-b__image block-b__image--1">
        <img src="../assets/img/block-b-1.jpg" alt="">
      </div>
      <div class="block-b__letter letter letter-line">
        Б.
      </div>
      <div class="block-b__image block-b__image--2">
        <img src="../assets/img/block-b-2.jpg" alt="">
        <img src="../assets/img/block-b-2-1.jpg" class="block-b__image--2-1" alt="">
      </div>
      <div class="block-b__image block-b__image--3">
        <img src="../assets/img/block-b-3.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockB',
}
</script>

<style lang="sass">
  .block-b
    height: vw(329px)
    position: relative
    z-index: 400
    margin-bottom: vw(-2px)
    &__bg
      width: 110vw
      height: vw(292px)
      margin-top: vw(29px)
      background-image: url(../assets/img/film.png)
      background-size: 87.6vw
      background-repeat: repeat-x
      background-position: 22% 0
      position: absolute
      z-index: 300
      @media screen and (max-width: 999px)
        display: none
    &__content
      display: flex
      align-items: center
      padding-top: vw(27px) 
      padding-right: vw(13px)
      position: relative
      z-index: 400
    &__letter
      margin-right: vw(57px)
      padding-left: vw(26px) 
      padding-top: vw(12px) 
      @media screen and (max-width: 999px)
        color: #000
        border-color: #000
        margin-left: vwm(23px)
        margin-top: vwm(65px)
        width: vwm(177px)
        &:before
          border-color: #000
        &:after
          border-color: #000
    &__image
      @media screen and (max-width: 999px)
        display: none
      img
        width: 100%
      &--1
        width: vw(376px)
        min-width: vw(376px)
        margin-right: vw(52px)
      &--2
        width: vw(391px)
        min-width: vw(391px)
        position: relative
        &-1
          animation: showHide
          animation-duration: 5000ms
          animation-timing-function: linear
          animation-iteration-count: infinite
          position: absolute
          left: 0
      &--3
        width: vw(301px)
        min-width: vw(301px)
        margin-left: auto
  @keyframes showHide
    0%
      opacity: 0
    45%
      opacity: 0
    50%
      opacity: 1
    95%
      opacity: 1
    100%
      opacity: 0
</style>
